// extracted by mini-css-extract-plugin
export default {"container":"stats_container__SvpDd"};